import React from "react";
import "./Blogs.css";
import BD_1 from "../assets/BD_1.jpg";
import BD_2 from "../assets/BD_2.jpg";
import BD_3 from "../assets/BD_3.jpg";
import BD_4 from "../assets/BD_4.jpg";

const blogs = [
  {
    id: 1,
    title: "Why Hyderabad is the Best City for Real Estate Investment in 2025",
    description:
      "Explore the factors like IT boom, infrastructure growth, and affordable housing that make Hyderabad a hot spot for real estate investors.",
    image:
      "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=800&q=60",
  },
  {
    id: 2,
    title: "Top Emerging Residential Localities in Hyderabad to Watch Out For",
    description:
      "Highlight new and upcoming neighborhoods such as Gachibowli, Kondapur, and Nallagandla that offer great potential for homebuyers.",
    image: BD_1,
  },
  {
    id: 3,
    title: "How the Hyderabad Metro is Transforming Real Estate Value",
    description:
      "Analyze how metro connectivity boosts property prices and makes commuting easier in key areas across Hyderabad.",
    image: BD_2,
  },
  {
    id: 4,
    title: "Guide to Buying Affordable Flats in Hyderabad Without Compromise",
    description:
      "Tips for first-time buyers on finding budget-friendly apartments that meet quality standards and have good amenities.",
    image: BD_3,
  },
  {
    id: 5,
    title: "Impact of IT Sector Growth on Hyderabad’s Commercial Real Estate Market",
    description:
      "Discuss how Hyderabad’s tech industry expansion drives demand for office spaces, co-working hubs, and retail properties.",
    image:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=60",
  },
  {
    id: 6,
    title: "Sustainable Real Estate Development Trends in Hyderabad",
    description:
      "Explore how eco-friendly construction and green buildings are shaping the future of Hyderabad’s property market.",
    image:
      "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=800&q=60",
  },
];

export default function Blogs() {
  return (
    <div className="container my-5 py-5">
      <div className="row g-4">
        {blogs.map(({ id, title, description, image }) => (
          <div key={id} className="col-md-6 col-lg-4">
            <div className="custom-card-blog p-3 h-100 d-flex flex-column">
              <img src={image} alt={title} className="blog-image mb-3" />
              <h3>{title}</h3>
              <p>{description}</p>
              <button className="cta">
  <span>Hover me</span>
  <svg width="15px" height="10px" viewBox="0 0 13 10">
    <path d="M1,5 L11,5"></path>
    <polyline points="8 1 12 5 8 9"></polyline>
  </svg>
</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
